/* eslint-disable @next/next/no-img-element */
import * as React from "react"

import { cn } from "@/lib/utils"

export interface VideoProps
  extends React.VideoHTMLAttributes<HTMLVideoElement> {
  mp4Src: string;
  webmSrc: string;
  fallbackSrc?: string;
}

const Video = React.forwardRef<HTMLVideoElement, VideoProps>(
  ({ className, mp4Src, webmSrc, fallbackSrc, ...props }, ref) => {
    return (
      <video
        ref={ref}
        className={cn(
          "w-full h-full object-cover",
          className,
        )}
        controls={false}
        preload="auto"
        autoPlay={true}
        muted={true}
        loop={true}
        {...props}
      >
        <source src={mp4Src} type="video/mp4" />
        <source src={webmSrc} type="video/webm" />
        {
          fallbackSrc ? (
            <img
              src={fallbackSrc}
              alt="Fallback"
              className={cn(
                "w-full h-full object-cover",
                className,
              )} />
          ) : null
        }
      </video>
    )
  }
)
Video.displayName = "Video"

export { Video }
